import script from "./UIEscapeSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./UIEscapeSuccess.vue?vue&type=script&setup=true&lang=js"

import "./UIEscapeSuccess.vue?vue&type=style&index=0&id=7535c510&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7535c510"]])

export default __exports__